import React from 'react'
import Dropzone from 'react-dropzone'
import { Button, Modal, } from 'react-bootstrap'

export default class UploadModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      fileName: '',
      fileSize: null,
      jsonDropped: false,
      parsedObject: {}
    }
    this.handleDropAccepted = this.handleDropAccepted.bind(this)
  }
  
  // モーダルでファイルアップロード受付
  handleDropAccepted (acceptedFiles) {
    const reader = new FileReader()
    reader.onabort = () => {
      window.alert('ファイルの読み込みが中断されました。')
      this.setState({jsonDropped: false})
    }
    
    reader.onerror = () => {
      window.alert('ファイルの読み込み中にエラーが発生しました。')
      this.setState({jsonDropped: false})
    }
    
    reader.onload = () => {
      this.setState({
        fileName: acceptedFiles[0].name,
        fileSize: acceptedFiles[0].size,
        jsonDropped: true,
        parsedObject: JSON.parse(reader.result)
      })
    }
    reader.readAsText(acceptedFiles[0])
  }
  
  render () {
    return (
      <React.Fragment>
        {/*File Upload*/}
        <Modal show={this.props.showUploadModal} backdrop={true} keyboard={true} bsSize="large" id="uploadModal">
          <Modal.Header closeButton>
            <Modal.Title id='jsonDropZone'>Upload JSON</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Dropzone className={`drag_drop ${this.state.jsonDropped ? 'dropped' : ''}`}
                      onDropAccepted={this.handleDropAccepted}
                      accept="application/json"
                      style={{
                        height: this.state.jsonDropped ? '40px' : '300px',
                        width: '100%',
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        textAlign: 'center',
                        margin: 'auto',
                        cursor: 'pointer'
                      }}
                      multiple={false}>
              <div>
                {this.state.jsonDropped
                  ? <h5>{this.state.fileName}</h5>
                  : <h5>Click or Drug and Drop</h5>}
              </div>
            </Dropzone>
          
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" id="modal"
                    onClick={e => this.props.handleClickOK(e, this.props, this.state.parsedObject)}>OK</Button>
            <Button bsStyle="default" id="modal"
                    onClick={e => this.props.handleClickCancel()}>キャンセル</Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadModal.js